import { render, staticRenderFns } from "./details-subscription-limits.vue?vue&type=template&id=cc7b0ece&scoped=true&"
import script from "./details-subscription-limits.vue?vue&type=script&lang=ts&"
export * from "./details-subscription-limits.vue?vue&type=script&lang=ts&"
import style0 from "./details-subscription-limits.vue?vue&type=style&index=0&id=cc7b0ece&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc7b0ece",
  null
  
)

export default component.exports